var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend-item"},[_c(_vm.icon,{tag:"component",class:{ 'legend-icon': _vm.icon, 'legend-emptytext': !_vm.icon }}),_c('span',[_vm._v(_vm._s(_vm.desc))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }